"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Item;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _classnames = _interopRequireDefault(require("classnames"));

var _label = _interopRequireDefault(require("./label"));

function Item({
  children,
  to,
  link,
  location,
  className,
  icon,
  onClick
}) {
  if (to) {
    return /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
      to: to,
      className: (0, _classnames.default)("navbar-item", {
        "is-active": location.pathname === to
      }, className),
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      icon: icon
    }, children));
  } else {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: link,
      className: (0, _classnames.default)("navbar-item", {
        "is-active": location.pathname === to
      }, className),
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      icon: icon
    }, children));
  }
}

Item.propTypes = {
  to: _propTypes.default.string,
  link: _propTypes.default.string,
  location: _propTypes.default.object,
  children: _propTypes.default.any.isRequired,
  className: _propTypes.default.string,
  icon: _propTypes.default.string,
  onClick: _propTypes.default.func
};